import React, { useEffect, useState } from 'react';

import CheckmarkSvg from '@/components/common/CheckmarkSvg';
import InfoTooltipSvg from '@/components/common/InfoTooltipSvg';
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverClose } from '@/components/common/popover';
import TooltipClose from '@/components/common/TooltipCloseSvg';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';

import { AccordionButton } from '../Components/Accordion';
import { FormPassword } from '../Components/FormPassword';
import { usePayment } from '../Context/PaymentContext';
import { useAccount } from '../hooks/useAccount';

type AccordionState = {
    id: number;
    isOpen: boolean;
};

export const Profile = () => {
    useEffect(() => {}, []);
    const isAuthenticated = useAuthenticated();
    const { data, isFetching } = useAccount(isAuthenticated);
    const [showSuccessNotice, setShowSuccessNotice] = useState(false);
    const [successtype, setSuccessType] = useState(null);
    const [accordionStates, setAccordionStates] = useState<AccordionState[]>([
        { id: 0, isOpen: false },
        { id: 1, isOpen: false },
    ]);
    const { setMode } = usePayment();

    const handleShowNotice = (successType: string) => {
        setShowSuccessNotice(true);
        setSuccessType(successType);
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }, 100);
    };

    const handleAccordionStateChange = (accordionId: number, newIsOpen: boolean) => {
        if (newIsOpen) {
            const updatedStates = accordionStates.map((accordion) => ({
                ...accordion,
                isOpen: accordion.id === accordionId,
            }));
            setAccordionStates(updatedStates);
        } else {
            setAccordionStates((prevAccordionStates) => {
                const updatedStates = [...prevAccordionStates];
                const index = updatedStates.findIndex((accordion) => accordion.id === accordionId);

                if (index !== -1) {
                    updatedStates[index].isOpen = newIsOpen;
                }

                return updatedStates;
            });
        }
    };

    return (
        <>
            <div className="profile px-5 md:px-0">
                <h1 className="m-0 text-base font-bold text-[#1a1a1a] md:text-2xl md:leading-8">Your profile</h1>
                {showSuccessNotice && (
                    <div className="notice-card" style={{ border: '2px solid #006B00' }}>
                        <div className="notice-card__icon">
                            <CheckmarkSvg width="20" height="20" />
                        </div>
                        <div className="notice-card__message">
                            {successtype == 'password'
                                ? 'You have successfully changed your password'
                                : 'You have successfully added or changed your security question'}
                        </div>
                        <button className="notice-card__close" onClick={() => setShowSuccessNotice(false)}>
                            <TooltipClose />
                        </button>
                    </div>
                )}
                <div className="profile__box mt-4 flex flex-wrap justify-between gap-3 border-4 border-solid border-[#d1dde2] px-5 py-7 text-[13px] font-light leading-5 md:mt-10 md:gap-7">
                    <div className="flex-shrink-0 flex-grow-0">Email</div>
                    <div className="flex-1 font-semibold">
                        <span className="mr-2.5" data-qm-encrypt="true">{data?.Email}</span>
                        <Popover>
                            <PopoverTrigger>
                                <span className="visually-hidden">Multipack Shipping Discount Tooltip</span>
                                <InfoTooltipSvg />
                            </PopoverTrigger>
                            <PopoverContent portalID="summary">
                                To change your email, please call 1-888-2020-888.
                                <PopoverClose />
                                <PopoverArrow />
                            </PopoverContent>
                        </Popover>
                    </div>
                </div>
                <div className="profile__password my-5 bg-[#f8f8f8] px-5 py-3">
                    <AccordionButton
                        defaultopen={false}
                        title="Change password"
                        ariaControls="profileAccordion1"
                        id={0}
                        setMode={setMode}
                        singleOpenMode={true}
                        onChange={handleAccordionStateChange}
                        stateFromParent={accordionStates[0].isOpen}
                        accordionStates={accordionStates}
                        setAccordionStates={setAccordionStates}
                    >
                        {/* Change Password  */}
                        <FormPassword
                            email={data?.Email}
                            showSuccess={handleShowNotice}
                            handleAccordion={handleAccordionStateChange}
                        />
                    </AccordionButton>
                </div>
            </div>
        </>
    );
};
export default Profile;
